import './scratch/style';
import FormStructure from './scratch/form_structure';

export default FormStructure;